module.exports = {
  imgur: {
    clientID: '8e0bcefe23bb338',
  },
};



//////////////////
// WEBPACK FOOTER
// ./configs.js
// module id = 184
// module chunks = 0